module.exports = __webpack_public_path__ + "img/P05-20140588-002-3.87022952.jpg";